import { render, staticRenderFns } from "./adjust-policy-info.vue?vue&type=template&id=2c2b9906&scoped=true&"
import script from "./adjust-policy-info.vue?vue&type=script&lang=js&"
export * from "./adjust-policy-info.vue?vue&type=script&lang=js&"
import style0 from "./adjust-policy-info.vue?vue&type=style&index=0&id=2c2b9906&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2b9906",
  null
  
)

export default component.exports